import React, { useState, useEffect, useRef } from "react";
import { FaCheckCircle, FaStar } from "react-icons/fa";
import { PaperBG } from "../kits";
import { motion, AnimatePresence } from "framer-motion";
import howItWorksData from "../data/howItWorks.json";
import RoughBorder from "../kits/LayoutKit/RoughBorder";
import RoughCircle from "../kits/LayoutKit/RoughCircle"; // Pfad anpassen

function HowItWorks() {
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const testimonials = howItWorksData.testimonials;
  const t = testimonials[testimonialIndex];

  // Slider-Ref für RoughBorder (Slider)
  const sliderRef = useRef();
  // Features-Ref für RoughBorder (Features)
  const featuresRef = useRef();

  // Automatischer Slider-Wechsel
  useEffect(() => {
    const interval = setInterval(() => {
      setDirection(1);
      setTestimonialIndex((i) =>
        i === testimonials.length - 1 ? 0 : i + 1
      );
    }, 6000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const prev = () => {
    setDirection(-1);
    setTestimonialIndex((i) =>
      i === 0 ? testimonials.length - 1 : i - 1
    );
  };
  const next = () => {
    setDirection(1);
    setTestimonialIndex((i) =>
      i === testimonials.length - 1 ? 0 : i + 1
    );
  };

  // Framer Motion Variants
  const variants = {
    enter: (direction) => ({
      x: direction > 0 ? 32 : -32,
      opacity: 0,
      filter: "blur(6px)",
      scale: 0.98,
      clipPath: "inset(0 100% 0 0)",
      position: "absolute",
    }),
    center: {
      x: 0,
      opacity: 1,
      filter: "blur(0px)",
      scale: 1,
      clipPath: "inset(0 0% 0 0)",
      position: "static",
      transition: {
        duration: 0.75,
        ease: [0.33, 1, 0.68, 1],
      },
    },
    exit: (direction) => ({
      x: direction < 0 ? 32 : -32,
      opacity: 0,
      filter: "blur(6px)",
      scale: 0.98,
      clipPath: "inset(0 100% 0 0)",
      position: "absolute",
    }),
  };

  return (

      <section className="py-16 ">
        <div className="container mx-auto px-6 md:max-w-4xl relative">
          {/* ohne  Features-Box */}
    

          {/* Testimonials-Slider */}
          <div
            ref={sliderRef}
            className="mt-10 md:mt-20 px-6 pt-6 pb-14 sm:p-8 sm:pb-12
           bg-gradient-to-br from-[#FAF6F1] to-[#F5EFE7]
            rounded-xl text-center w-full z-20 shadow-lg relative min-h-[380px] sm:min-h-[350px] flex flex-col justify-between"
          >
            {/* Slider-Buttons - weiter nach außen auf Mobile */}
            <button
              onClick={prev}
              className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 bg-white border border-black rounded-full w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center shadow hover:bg-gray-100 z-30"
              aria-label="Vorheriges Testimonial"
            >
              ‹
            </button>
            <button
              onClick={next}
              className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2
              bg-gradient-to-br from-[#FAF6F1] to-[#F5EFE7]
              border border-black rounded-full w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center shadow hover:bg-gray-100 z-30"
              aria-label="Nächstes Testimonial"
            >
              ›
            </button>

            <div className="relative flex-1 flex items-center justify-center px-6 sm:px-8">
              <AnimatePresence initial={false} custom={direction} mode="wait">
                <motion.div
                  key={testimonialIndex}
                  custom={direction}
                  variants={variants}
                  initial="enter"
                  animate="center"
                  exit="exit"
                  transition={{
                    duration: 0.75,
                    ease: [0.33, 1, 0.68, 1],
                  }}
                  className="w-full"
                >
                  <div>
                   <div className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-full
                   bg-gradient-to-br from-[#FAF6F1] to-[#F5EFE7] shadow-lg
                   flex items-center justify-center mx-auto mb-3 sm:mb-4">
  <img
    src={`${process.env.PUBLIC_URL}${t.image}`}
    alt={t.name}
    className="object-contain w-[55%] h-[55%] z-20"
  />
  {/* Mobile circle (80px = w-20) */}
  <RoughCircle diameter={80} strokeWidth={1.2} color="#AC8E66" roughness={0.8} className="sm:hidden" />
  {/* Desktop circle (96px = w-24) */}
  <RoughCircle diameter={96} strokeWidth={1.2} color="#AC8E66" roughness={0.8} className="hidden sm:block" />
</div>
                    <h3 className="text-xs sm:text-sm font-mono text-black-800 tracking-tighter">
                      {t.name} {t.company}
                    </h3>
                    <div className="flex justify-center text-brand mt-1 sm:mt-2 mb-2 sm:mb-4">
                      {Array.from({ length: t.stars }).map((_, i) => (
                        <FaStar key={i} className="text-sm sm:text-base" />
                      ))}
                    </div>
                    <p className="mt-2 sm:mt-4 border-gray-300 font-mono text-xs text-gray-800 leading-relaxed">
                      {t.quote}
                    </p>
                    <p className="mt-2 sm:mt-4 font-mono text-xs sm:text-sm">{t.role}</p>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

            {/* Indikatoren - fest am unteren Rand */}
            <div className="flex justify-center gap-1 absolute bottom-4 left-0 right-0">
              {testimonials.map((_, i) => (
                <span
                  key={i}
                  className={`block w-2 h-2 rounded-full ${
                    i === testimonialIndex ? "bg-brand" : "bg-gray-300"
                  }`}
                ></span>
              ))}
            </div>

            {/* RoughBorder für Slider-Card */}
            <RoughBorder
              parentRef={sliderRef}
              radius={10}
              padding={2}
            color="#AC8E66" 
              strokeWidth={0.3}
              roughness={1}
              bowing={2}
            />
          </div>
        </div>
      </section>

  );
}

export default HowItWorks;
